export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "stanleybet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "stanleybet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
